import { render, staticRenderFns } from "./ReviewsIndex.vue?vue&type=template&id=133db1e4&"
import script from "./ReviewsIndex.vue?vue&type=script&lang=js&"
export * from "./ReviewsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports